import { ErrorMessage } from 'ng-bootstrap-form-validation';

export const CUSTOM_VALIDATION_ERRORS: ErrorMessage[] = [
  {
    error: 'required',
    format: requiredFormat
  }, {
    error: 'email',
    format: emailFormat
  }, {
    error: 'pattern',
    format: patternFormat
  }, {
    error: 'mustMatch',
    format: mustMatchFormat
  }, {
    error: 'invalidCPF',
    format: invalidCPFFormat
  }
];

export function requiredFormat(label: string, error: any): string {
  return `O campo ${label} é obrigatório.`;
}

export function emailFormat(label: string, error: any): string {
  return `O campo ${label} é inválido.`;
}

export function patternFormat(label: string, error: any): string {
  return `O campo ${label} é inválido.`;
}

export function mustMatchFormat(label: string, error: any): string {
  return `O campo ${label} é diferente.`;
}

export function invalidCPFFormat(label: string, error: any): string {
  return `O campo ${label} é inválido.`;
}
